import * as ACTION_TYPES from '@stores/actions/action_types'

export interface ShopStateType {
  upload_logo_loading: boolean
  remove_logo: boolean
  shop: Record<string, A>
  error: string[]
  currencies: A[]
  subscription: {
    shopify_domain: string
    created_at: string
    name: string
    attached_pdf: boolean
    billing_cycle: string
    country_name: string
    currency: string
    download_file?: boolean // optional for backward compatibility
    bulk_download_separate_pdfs?: boolean // optional for backward compatibility
    from_pro: boolean
    is_new_shop: boolean
    limit_draft_order: number
    limit_order: number
    minimum_order_select_to_download: number
    onboarding: boolean
    partner_development: boolean
    plan: string
    pre: boolean
    primary_language: string
    query_string: string
    remove_brand: boolean
    shop_email: string
    shop_id: number
    shopify_plus: boolean
    shorten_link: boolean
    survey_complete: boolean
    type_app: string
    chatwoot_identifier?: string
    chatwoot_identifier_hash?: string
  }
  subscription_update: number // vì là Date.now()
  show_plan: boolean
}

const DEFAULT_STATE = {
  upload_logo_loading: false,
  remove_logo: false,
  shop: {},
  error: [],
  currencies: [],
  subscription: {
    name: '',
    shopify_domain: '',
    type_app: '',
    download_file: false, // legacy
    bulk_download_separate_pdfs: false, // enhanced
    download_file_name: '',
    minimum_order_select_to_download: 1,
    pre: false,
    from_pro: false,
  },
  subscription_update: Date.now(),
  show_plan: false,
}

export const getInitialState = (): ShopStateType => {
  try {
    const stored = localStorage.getItem('whoami')
    if (stored) {
      const parsed = JSON.parse(stored) as Record<string, unknown>
      if (parsed && typeof parsed === 'object') {
        // Handle legacy key and new key for bulk download flag
        const bulk = parsed.bulk_download_separate_pdfs ?? parsed.download_file
        return {
          ...DEFAULT_STATE,
          subscription: {
            ...DEFAULT_STATE.subscription,
            ...parsed,
            bulk_download_separate_pdfs:
              bulk === true || bulk === 'true' || bulk === 1 || bulk === '1',
          } as unknown as ShopStateType['subscription'],
        }
      }
    }
  } catch (_e) {
    /* noop */
  }
  return DEFAULT_STATE as unknown as ShopStateType
}

export const initialState = getInitialState()

const ShopReducer = (state: ShopStateType, action: A) => {
  switch (action.type) {
    case ACTION_TYPES.APP_LOAD:
      return {
        ...state,
        subscription: action.state.current_shop,
      }
    case ACTION_TYPES.UPLOAD_LOGO:
      return {
        ...state,
        upload_logo_loading: true,
      }
    case ACTION_TYPES.UPLOAD_LOGO_SUCCESS:
      return {
        ...state,
        shop: action.data,
        upload_logo_loading: false,
        remove_logo: false,
        error: action.error,
      }
    case ACTION_TYPES.GET_SHOP:
      return {
        ...state,
        shop: action.shop ?? action.payload ?? state.shop,
      }
    case ACTION_TYPES.REMOVE_LOGO:
      return {
        ...state,
        remove_logo: action.remove_logo,
      }
    case ACTION_TYPES.SET_CURRENCIES:
      return {
        ...state,
        currencies: action.currencies,
      }
    case ACTION_TYPES.SET_SHOP:
      return {
        ...state,
        subscription: action.payload,
      }
    case ACTION_TYPES.SUBSCRIPTION_UPDATE:
      return {
        ...state,
        subscription_update: Date.now(),
      }
    case ACTION_TYPES.SET_BOARDING_SHOP:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          onboarding: action.onboarding,
        },
      }
    case ACTION_TYPES.SUBSCRIPTION_SHOPIFY_PLUS:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          shopify_plus: action.shopify_plus,
        },
      }
    case ACTION_TYPES.SHOW_PLAN:
      return {
        ...state,
        show_plan: !state.show_plan,
      }
    default:
      return state
  }
}
export default ShopReducer
